export enum TipoModeloEnum {
  EDITOR = 'EDITOR',
  OFFICE = 'OFFICE'
}

export const tipoModeloEnumFormatado = {
  EDITOR: 'Editor',
  OFFICE: 'Office'
};
